import { Node, mergeAttributes } from '@tiptap/core';

/**
 * An inline, atomic `variable` node rendered as a pill in the editor. It stores
 * the dotted variable key in `attrs.name` (e.g. `contact.name`) so the server
 * renderer (DocumentGeneration::ProsemirrorRenderer#render_variable) can turn it
 * back into a `{{ name }}` Liquid placeholder on a lossless round-trip.
 */
export const VariableNode = Node.create({
  name: 'variable',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,

  addAttributes() {
    return {
      name: {
        default: null,
        parseHTML: element => element.getAttribute('data-name'),
        renderHTML: attributes =>
          attributes.name ? { 'data-name': attributes.name } : {},
      },
      label: {
        default: null,
        parseHTML: element => element.getAttribute('data-label'),
        renderHTML: attributes =>
          attributes.label ? { 'data-label': attributes.label } : {},
      },
    };
  },

  parseHTML() {
    return [{ tag: 'span[data-name]' }];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, { class: 'template-variable' }),
      node.attrs.label || node.attrs.name || '',
    ];
  },

  renderText({ node }) {
    return `{{ ${node.attrs.name} }}`;
  },

  addCommands() {
    return {
      insertVariable:
        attributes =>
        ({ chain }) =>
          chain()
            .insertContent({ type: this.name, attrs: attributes })
            .insertContent(' ')
            .run(),
    };
  },
});

export default VariableNode;
